var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarriere(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.909 10.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0a4 4 0 011.333 7.772V36H7a1 1 0 011 1v.667a1 1 0 01-1 1H1a1 1 0 01-1-1V37a1 1 0 011-1h1.666V7.772A4.002 4.002 0 01.006 4.2L0 4a4 4 0 014-4z",
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB511",
    cx: 4,
    cy: 4,
    r: 2.667
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.242 10.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0a4 4 0 011.333 7.772V36H7a1 1 0 011 1v.667a1 1 0 01-1 1H1a1 1 0 01-1-1V37a1 1 0 011-1h1.666V7.772A4.002 4.002 0 014 0z",
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB511",
    cx: 4,
    cy: 4,
    r: 2.667
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DAE8EC",
    d: "M5.909 20h6.667v21.333H5.909zm13.333 0h6.667v21.333h-6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74536",
    d: "M12.576 20h6.667v21.333h-6.667zm13.333 0h6.667v21.333h-6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAE8EC",
    d: "M32.576 20h6.667v21.333h-6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74536",
    d: "M39.242 20h6.667v21.333h-6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAE8EC",
    d: "M45.909 20h6.667v21.333h-6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74536",
    d: "M52.576 20h6.667v21.333h-6.667z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjUiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NSA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUuOTA5IDEwLjY2NykiPgogICAgICAgICAgICA8cGF0aCBkPSJNNCAwYTQgNCAwIDAgMSAxLjMzMyA3Ljc3MlYzNkg3YTEgMSAwIDAgMSAxIDF2LjY2N2ExIDEgMCAwIDEtMSAxSDFhMSAxIDAgMCAxLTEtMVYzN2ExIDEgMCAwIDEgMS0xaDEuNjY2VjcuNzcyQTQuMDAyIDQuMDAyIDAgMCAxIC4wMDYgNC4yTDAgNGE0IDQgMCAwIDEgNC00eiIgZmlsbD0iIzBGMTk0MSIvPgogICAgICAgICAgICA8Y2lyY2xlIGZpbGw9IiNGRkI1MTEiIGN4PSI0IiBjeT0iNCIgcj0iMi42NjciLz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMjQyIDEwLjY2NykiPgogICAgICAgICAgICA8cGF0aCBkPSJNNCAwYTQgNCAwIDAgMSAxLjMzMyA3Ljc3MlYzNkg3YTEgMSAwIDAgMSAxIDF2LjY2N2ExIDEgMCAwIDEtMSAxSDFhMSAxIDAgMCAxLTEtMVYzN2ExIDEgMCAwIDEgMS0xaDEuNjY2VjcuNzcyQTQuMDAyIDQuMDAyIDAgMCAxIDQgMHoiIGZpbGw9IiMwRjE5NDEiLz4KICAgICAgICAgICAgPGNpcmNsZSBmaWxsPSIjRkZCNTExIiBjeD0iNCIgY3k9IjQiIHI9IjIuNjY3Ii8+CiAgICAgICAgPC9nPgogICAgICAgIDxnPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjREFFOEVDIiBkPSJNNS45MDkgMjBoNi42Njd2MjEuMzMzSDUuOTA5ek0xOS4yNDIgMjBoNi42Njd2MjEuMzMzaC02LjY2N3oiLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0U3NDUzNiIgZD0iTTEyLjU3NiAyMGg2LjY2N3YyMS4zMzNoLTYuNjY3ek0yNS45MDkgMjBoNi42Njd2MjEuMzMzaC02LjY2N3oiLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0RBRThFQyIgZD0iTTMyLjU3NiAyMGg2LjY2N3YyMS4zMzNoLTYuNjY3eiIvPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjRTc0NTM2IiBkPSJNMzkuMjQyIDIwaDYuNjY3djIxLjMzM2gtNi42Njd6Ii8+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNEQUU4RUMiIGQ9Ik00NS45MDkgMjBoNi42Njd2MjEuMzMzaC02LjY2N3oiLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0U3NDUzNiIgZD0iTTUyLjU3NiAyMGg2LjY2N3YyMS4zMzNoLTYuNjY3eiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgBarriere as ReactComponent };